import React from "react";
import Divider from "components/common/Divider";
import { Offcanvas, Card, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faFileInvoiceDollar,
    faCalendarAlt,
    faMoneyBillWave,
    faInfoCircle,
    faCreditCard,
    faHashtag,
    faLink,
    faFileAlt,
} from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import CLaimSingleViewTable from "./ClaimSingleViewTable";

const ClaimViewSinglePayment = ({ show, setShow, data, fromPage = false }) => {
    const payment = data?.payment_summary || {};

    const LabelValue = ({ icon, label, value, isLink = false, colorClass = "text-primary" }) => (
        <div className="mb-2">
            <div className={`d-flex align-items-center ${colorClass}  mb-1 fs-11`}>
                <FontAwesomeIcon icon={icon} className={`me-2 ${colorClass}`} />
                <span className={`fw-bold ${colorClass}`}>{label}</span>
            </div>
            <div className={`fs-11 fw-medium text-600 `}>
                {isLink && value ? (
                    <a href={value} target="_blank" rel="noopener noreferrer">
                        {value}
                    </a>
                ) : (
                    value || ""
                )}
            </div>
        </div>
    );

    return (
        <>
            <Offcanvas
                placement="end"
                show={show}
                className="w-100 w-md-80 w-lg-60 w-xl-50 border-0"
                onHide={() => setShow(false)}
            >
                <Offcanvas.Header closeButton className="pb-2">
                    <Offcanvas.Title className="fs-9 fw-bold">
                        <FontAwesomeIcon icon={faFileInvoiceDollar} className="me-2 text-primary" />
                        View Single Payment
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Divider className="mt-0 pt-0" />
                <Offcanvas.Body className="p-2">
                    {payment ? (
                        <Card className="shadow-sm mb-3">
                            <Card.Header className="bg-primary text-white p-2 d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <FontAwesomeIcon icon={faFileInvoiceDollar} className="me-2" />
                                    <h6 className="mb-0 text-white fs-11 fw-bold">Payment Summary</h6>
                                </div>
                                {/* Optional: Add status badge if available in data, mostly not in the snippet provided but good to have a placeholder or similar */}
                                {/* <SubtleBadge bg="success" className="text-white border-0">Processed</SubtleBadge> */}
                            </Card.Header>
                            <Card.Body className="p-3">
                                <Row className="g-2 mb-3">
                                    <Col xs={6}>
                                        <div className="p-2 rounded-2 border h-100">
                                            <div className="d-flex align-items-center text-600 mb-1 fs-11">
                                                <FontAwesomeIcon icon={faFileAlt} className="me-2 text-primary" />
                                                <span className="fw-bold text-800">Payment No.</span>
                                            </div>
                                            <div className="fs-12 fw-bold text-400 text-truncate">
                                                {payment?.paymentno || "N/A"}
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xs={6}>
                                        <div className="p-2 rounded-2 bg-soft-success border border-success-subtle h-100">
                                            <div className="d-flex align-items-center text-success mb-1 fs-11">
                                                <FontAwesomeIcon icon={faMoneyBillWave} className="me-2" />
                                                <span className="fw-bold">Amount</span>
                                            </div>
                                            <div className="fs-12 fw-extrabold text-success">
                                                {payment?.paymentamount
                                                    ? `${parseFloat(payment.paymentamount).toLocaleString('en-US', { minimumFractionDigits: 2 })} SAR`
                                                    : "0.00 SAR"}
                                            </div>
                                        </div>
                                    </Col>
                                </Row>

                                {/* Grid Details */}
                                <Row className="g-3">
                                    <Col xs={4}>
                                        <LabelValue
                                            icon={faCalendarAlt}
                                            label="Period Start"
                                            colorClass="text-info"
                                            value={payment?.periodstart ? moment(payment.periodstart).format("DD-MM-YYYY") : null}
                                        />
                                    </Col>
                                    <Col xs={4}>
                                        <LabelValue
                                            icon={faCalendarAlt}
                                            label="Period End"
                                            colorClass="text-info"
                                            value={payment?.periodend ? moment(payment.periodend).format("DD-MM-YYYY") : null}
                                        />
                                    </Col>
                                    <Col xs={4}>
                                        <LabelValue
                                            icon={faCalendarAlt}
                                            label="Payment Date"
                                            colorClass="text-primary"
                                            value={payment?.paymentdate ? moment(payment.paymentdate).format("DD-MM-YYYY") : null}
                                        />
                                    </Col>
                                    <Col xs={4}>
                                        <LabelValue
                                            icon={faInfoCircle}
                                            label="Disposition"
                                            colorClass="text-warning"
                                            value={payment?.disposition}
                                        />
                                    </Col>
                                    <Col xs={4}>
                                        <LabelValue
                                            icon={faCreditCard}
                                            label="Payment Method"
                                            colorClass="text-secondary"
                                            value={payment?.paymentmethod}
                                        />
                                    </Col>
                                    <Col xs={4}>
                                        <LabelValue
                                            icon={faHashtag}
                                            label="Payment Via"
                                            colorClass="text-danger"
                                            value={payment?.paymentmethodval}
                                        />
                                    </Col>
                                    <Col xs={12}>
                                        <LabelValue
                                            icon={faLink}
                                            label="Payment Ref No."
                                            colorClass="text-primary"
                                            value={payment?.paymentmethodurl}
                                            isLink={true}
                                        />
                                    </Col>
                                </Row>

                            </Card.Body>
                        </Card>
                    ) : (
                        <div className="text-center p-3 text-muted">No Payment Data Available</div>
                    )}

                    <Card className="shadow-sm">
                        <Card.Header className="bg-primary text-white p-2 d-flex justify-content-between align-items-center">
                            <div className="d-flex align-items-center">
                                <FontAwesomeIcon icon={faLink} className="me-2" />
                                <h6 className="mb-0 text-white fs-11 fw-bold">Payment Claims Detail</h6>
                            </div>
                        </Card.Header>
                        <Card.Body className="p-0">
                            <CLaimSingleViewTable
                                data={data?.payment_recon || []}
                                date={data?.payment_summary?.paymentdate}
                                fromPage={fromPage}
                                setShow={setShow}
                            />
                        </Card.Body>
                    </Card>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default ClaimViewSinglePayment;
